import { RootState } from '@/store';
import { ActionContext, ActionTree } from 'vuex';
import { State } from './state';
import {
    SET_USER_TYPE_LIST,
    FETCH_USER_TYPE_LIST,
    CREATE_USER_TYPE_LIST,
    SET_SELECTED_USER_TYPE,
    CREATE_USER_TYPE,
    ADD_USER_TYPE_TO_LIST,
    UPDATE_REGISTER_FORM_VISIBILITY,
    SET_USER_FORM_VISIBILITY,
    UPDATE_USER_TYPE_LIST,
    UPDATE_USER_TYPE,

} from './types';
import { userTypeApi } from '@/api/userType.api';
import { IUserType } from '../models';
import { MessageService } from '@/services/messageService';

export const actions: ActionTree<State, RootState> = {
    async [FETCH_USER_TYPE_LIST]({ commit }, payload: State) {
        return userTypeApi.getAll().catch((error: any) => {MessageService.Error('Erro', error); } );
    },
    async [CREATE_USER_TYPE_LIST]({ commit }, payload: State) {
        commit(SET_USER_TYPE_LIST, payload);
    },
    async [SET_SELECTED_USER_TYPE]({ commit }, payload: State) {
        commit(SET_SELECTED_USER_TYPE, payload);
    },
    async [UPDATE_REGISTER_FORM_VISIBILITY]({ commit }, payload: boolean) {
        commit(SET_USER_FORM_VISIBILITY, payload);
    },
    async [CREATE_USER_TYPE]({ commit }, payload: IUserType) {
        return userTypeApi.addUserType(payload).catch((error: any) => {MessageService.Error('Erro', error); } );
    },
    async [UPDATE_USER_TYPE_LIST]({ commit }, payload: IUserType) {
        commit(ADD_USER_TYPE_TO_LIST, payload);
    },
    async [UPDATE_USER_TYPE]({ commit }, payload: IUserType) {
        return userTypeApi.updateUserType(payload).catch((error: any) => {MessageService.Error('Erro', error); } );
    },
};
